<app-breadcrumb  [master]="'Analizy'" [parentName]="'Identyfikatory'" [name]="'Raporty'"></app-breadcrumb>
<div class="report-identifier-list-container">
  <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="report-identifier-list-filters">
    <ng-container >
      <app-dict-ofwcas
        [multiple]="false"
        label="OFWCA" class="report-identifier-list-filter"
        [(ngModel)]="initialFilters.ofwca" name="ofwca"
      ></app-dict-ofwcas>

      <app-dict-insurance-companies
        (selectedInsuranceCompanies)="insuranceCompanyFilterChanged($event)"
        [multiple]="true"
        label="TU" class="report-identifier-list-filter"
        [(ngModel)]="initialFilters.insuranceCompany" name="insuranceCompany"
      ></app-dict-insurance-companies>

      <app-dict
        [multiple]="false" label="Status"
        class="report-identifier-list-filter"
        dictType="registration_status"
        [(ngModel)]="initialFilters.status" name="status"
      ></app-dict>

      <app-dict
        [onlyKeys]="typeOnlyKeys" [multiple]="false"
        label="Rodzaj" class="report-identifier-list-filter"
        dictType="registration_id_type"
        [(ngModel)]="initialFilters.type" name="type"
      ></app-dict>

      <mat-form-field class="report-identifier-list-filter">
        <mat-label>Identyfikator</mat-label>
        <input matInput placeholder="12345"
               name="contains$value" [(ngModel)]="initialFilters.contains$value"
        >
      </mat-form-field>

      <app-dict-partners
        [multiple]="false" label="Partner"
        class="report-identifier-list-filter"
        [(ngModel)]="initialFilters.partner" name="partner"
      ></app-dict-partners>

      <app-dict-regionals
        [multiple]="true" label="Regionalny (majątek)"
        class="report-identifier-list-filter"
        [(ngModel)]="initialFilters.assetsRegional" name="assetsRegional"
      ></app-dict-regionals>

      <mat-form-field appearance="standard" class="report-identifier-list-filter">
        <mat-label>Identyfikatory wartość</mat-label>
        <mat-select [(ngModel)]="initialFilters.valueIdentifiers" name="valueIdentifiers">
          <mat-option [value]="1">Tak</mat-option>
          <mat-option [value]="0">Nie</mat-option>
        </mat-select>
      </mat-form-field>

    </ng-container>
  </form>

  <div class="report-identifier-list-buttons" >
    <button *ngIf="(userPermissions | async).analysis.read_report" (click)="downloadReport()" [disabled]="!(userPermissions | async).analysis.read_report"
            mat-raised-button class="report-button"><mat-icon>download</mat-icon> <span> Pobierz raport</span></button>
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>

</div>
